export const USER_UPDATE_TESTIMONIAL_CREDENTIALS =
  "USER_UPDATE_TESTIMONIAL_CREDENTIALS";
export const USER_UPDATE_HOMEBEAT_STATUS = "USER_UPDATE_HOMEBEAT_STATUS";
